<template>
    <b-modal ref="mdlAssociaProgetto" title="Aggiungi progetto" centered no-close-on-backdrop no-close-on-esc size="xl">
        <div class="sa-list-component sa-paziente-associa-progetto-modale">
            <div class="sa-list-component-header">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>{{ $i18n.t("global.lblTotalRecords") }}: {{ totalRows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>

            <div class="sa-list-component-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header stacked="lg" striped hover :items="progettiDisponibili" :fields="fieldsProgettiDisponibili" :current-page="1" :per-page="perPage" :key="listKeyProgettiDisponibili" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(dataInizio)="{ item }">
                            {{ formatDate(item.dataInizio) }}
                        </template>
                        <template #cell(dataFine)="{ item }">
                            {{ formatDate(item.dataFine) }}
                        </template>
                        <template #cell(actions)="{ item }">
                            <b-button v-if="isProgettoAssociato(item)" size="sm" variant="outline-danger" @click="onClickDissociaProgetto(item)">
                                <b-icon icon="person-x-fill"></b-icon>
                                Dissocia
                            </b-button>
                            <b-button v-else size="sm" variant="outline-success" @click="onClickAssociaProgetto(item)">
                                <b-icon icon="person-plus-fill"></b-icon>
                                Associa
                            </b-button>
                        </template>
                    </b-table>
                </div>
            </div>
        </div>

        <template #modal-footer>
            <b-button variant="outline-danger" @click="onCloseModalAssociaProgetto">Chiudi</b-button>
        </template>
    </b-modal>
</template>

<script>
import UtilityMixins from "../../utility/UtilityMixin";

export default {
    mixins: [UtilityMixins],
    props: {
        idPaziente: String,
    },
    data() {
        return {
            pathResourceProgetti: "/pazientiprogetti",
            pathResourceAssociaProgetto: "/pazientiprogettianagrafica",
            progettiDisponibili: [],
            associazioniProgetti: [],
            totalRows: 0,
            perPage: 10,
            currentPage: 1,
            listKeyProgettiDisponibili: 0,
            fieldsProgettiDisponibili: [
                {
                    label: "Nome Progetto",
                    key: "nome",
                    sortable: true,
                },
                {
                    label: "Descrizione Progetto",
                    key: "descrizione",
                    sortable: true,
                },
                {
                    label: "Data Inizio",
                    key: "dataInizio",
                    sortable: true,
                },
                {
                    label: "Data Fine",
                    key: "dataFine",
                    sortable: true,
                },
                {
                    class: "sa-table-column-action",
                    key: "actions",
                    label: "",
                },
            ],
        };
    },
    watch: {
        currentPage() {
            this.loadDataProgettiDisponibili();
        },
    },
    methods: {
        show() {
            let me = this;
            me.loadDataAssociazioniProgetti();
            me.loadDataProgettiDisponibili();
            me.$refs.mdlAssociaProgetto.show();
        },
        loadDataProgettiDisponibili() {
            let me = this;
            let filtroProgettiDisponibili = {
                page: me.currentPage,
                forPage: me.perPage,
            };
            me.loadDataResources(me.pathResourceProgetti, filtroProgettiDisponibili, me.loadDataProgettiDisponibiliSuccess, me.loadDataProgettiDisponibiliError);
        },
        loadDataAssociazioniProgetti() {
            let me = this;
            let filtroAssociazioniProgetti = {
                idAnagrafica: me.idPaziente,
            };
            me.loadDataResources(me.pathResourceAssociaProgetto, filtroAssociazioniProgetti, me.loadDataAssociazioniProgettiSuccess, me.loadDataAssociazioniProgettiError);
        },
        loadDataAssociazioniProgettiSuccess(response) {
            let me = this;
            me.associazioniProgetti = response.data.data.list;
        },
        loadDataAssociazioniProgettiError(error) {
            let me = this;
            me.associazioniProgetti = [];
            me.errorToast(error);
        },
        loadDataProgettiDisponibiliSuccess(response) {
            let me = this;
            let data = response.data.data;
            me.progettiDisponibili = data.list;
            me.totalRows = response.data.data.recordsNumber;
            me.listKeyProgettiDisponibili++;
        },
        loadDataProgettiDisponibiliError(error) {
            let me = this;
            me.progettiDisponibili = [];
            me.totalRows = 0;
            me.errorToast(error);
        },
        getAssociazioneProgetto(item) {
            let me = this;
            let Prova = me.associazioniProgetti.find((associazione) => String(associazione.idProgetto) === String(item.id));
            return Prova;
        },
        isProgettoAssociato(item) {
            let me = this;
            let associazione = me.getAssociazioneProgetto(item);
            return associazione !== null && associazione !== undefined;
        },
        onClickAssociaProgetto(item) {
            let me = this;
            let loadData = {
                idAnagrafica: me.idPaziente,
                idProgetto: item.id,
            };
            me.saveResource(me.pathResourceAssociaProgetto, loadData, me.saveAssociaProgettoSuccess, me.saveAssociaProgettoError);
        },
        saveAssociaProgettoSuccess() {
            let me = this;
            me.$bvToast.toast("Associazione avvenuta con successo", {
                title: "Success",
                variant: "success",
                solid: true,
            });
            me.onCloseModalAssociaProgetto();
            me.$emit("change");
        },
        saveAssociaProgettoError(error) {
            let me = this;
            me.errorToast(error);
        },
        onClickDissociaProgetto(item) {
            let me = this;
            let associazione = me.getAssociazioneProgetto(item);
            me.deleteResource(me.pathResourceAssociaProgetto + "/" + associazione.id, me.deleteAssociaProgettoSuccess, me.deleteAssociaProgettoError);
        },
        deleteAssociaProgettoSuccess() {
            let me = this;
            me.$bvToast.toast("Dissociazione avvenuta con successo", {
                title: "Success",
                variant: "success",
                solid: true,
            });
            me.loadDataAssociazioniProgetti();
            me.$emit("change");
        },
        deleteAssociaProgettoError(error) {
            let me = this;
            me.errorToast(error);
        },
        onCloseModalAssociaProgetto() {
            let me = this;
            me.$refs.mdlAssociaProgetto.hide();
        },
    },
};
</script>

<style scoped>
.sa-paziente-associa-progetto-modale .b-table-sticky-header {
    max-height: 480px;
}
</style>
